import { IContent } from 'models/content.model';

const content: IContent = {
  nl: {
    pageTitle: 'Messenger',
    contact: {
      title: 'Neem contact met ons op en stel hier je vraag',
      text: 'We helpen je graag verder via onze Messenger. Dit gesprek vind je ook terug in de Mijn Ziggo app. <br> Tip: zet de ‘Meldingen’ aan via de Mijn Ziggo app. Dan krijg je direct een notificatie bij een nieuwe reactie.',
      button: 'Download de Mijn Ziggo App',
    },
  },
  en: {},
};

export default content;
